module.exports = __webpack_public_path__ + "img/safe-info-hazard-reagent.0ca5656b.svg";